var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"change":_vm.onChange}}),_c('span',{staticClass:"slider"})]),_c('span',{staticClass:"input-error",class:{ 'input-error--show': _vm.error }},[_vm._v(_vm._s(_vm.say[_vm.error]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }